<template lang="pug">
  .wrap
    StartingBusinessSidebar(:openSidebar="openSidebar" @toggleSidebar="toggleSidebar")

    .main
      .job-list
        .job-list-header(:class="{ 'job-list-header-fixed-sp': this.headerFixedSp }")
          StartingBusinessSortArea(@toggleSidebar="toggleSidebar")

        .job-list-body
          table.row-list
            StartingBusinessTableHeader(
              :checked="pageAllChecked",
              @check="togglePageCheck"
            )

            StartingBusinessTableRow(
              v-for="(v, i) in index",
              :startingBusiness="v",
              :index="i",
              :key="v.id",
              :checkedIds="pageCheckedIds",
              :updateFavorForIndex="true",
              @display="displayDetailModal",
              @check="toggleCheck"
            )
        Pagination(
          :pagination="pagination"
          @selectPerPage="selectPerPage"
          @selectPage="selectPage"
          @updatePerPage="updateJobsPerPage")
      StartingBusinessShowModal(
        :isOpened="openJobShowModal"
        :startingBusinessDetail="startingBusinessDetail"
        :updateFavorForIndex="true"
        @hide="hideJobShowModal"
        @update="skipReload")
      StartingBusinessMenu(@remove="reloadOrSkip" :checkedIds="checkedIdsAll")

    Footer
</template>

<script>
  import { mapActions, mapState, mapMutations, mapGetters } from 'vuex'
  import { ErrorMessages, perPages } from '../../constants'
  // import JobColumnSortModal from '../parts/JobColumnSortModal'
  import Footer from '../parts/Footer'
  import StartingBusinessShowModal from '../parts/StartingBusinessShowModal'
  import StartingBusinessSidebar from '../parts/StartingBusinessSidebar'
  import StartingBusinessSortArea from '../parts/StartingBusinessSortArea'
  import StartingBusinessTableHeader from '../parts/StartingBusinessTableHeader'
  import StartingBusinessTableRow from '../parts/StartingBusinessTableRow'
  import StartingBusinessMenu from '../parts/StartingBusinessMenu'
  import Pagination from '../parts/Pagination'

  export default {
    components: {
      // JobColumnSortModal,
      Footer,
      StartingBusinessShowModal,
      StartingBusinessSidebar,
      StartingBusinessSortArea,
      StartingBusinessTableHeader,
      StartingBusinessTableRow,
      StartingBusinessMenu,
      Pagination,
    },
    async asyncData ({ store, route: { query } }) {
      if (!Object.keys(query).length) {
        throw new Error(ErrorMessages.NO_PARAMETER_SEARCH_STARTING_BUSINESS)
      }
      if (!perPages.map(p => p.code).includes(query.perPage)) {
        throw new Error(ErrorMessages.INVALID_PER_PAGE_SEARCH_STARTING_BUSINESS)
      }

      await store.dispatch('startingBusiness/fetchIndex', query)
      await store.dispatch('client/fetch')
    },
    data () {
      return {
        headerFixedSp: false,
        openJobShowModal: false,
        openSidebar: false,
      }
    },
    mounted () {
      window.addEventListener('scroll', this.handleScroll)
    },
    destroyed () {
      window.removeEventListener('scroll', this.handleScroll)
    },
    created () {
      this.uncheckAll()
      this.avoidBlank()
    },
    computed: {
      ...mapGetters('startingBusiness', ['pageAllChecked']),
      ...mapGetters('common', ['spMode']),
      ...mapState({
        meta: state => state.route.meta,
        pagination: state => state.startingBusiness.pagination,
        index: state => state.startingBusiness.index,
        pageCheckedIds: state => state.startingBusiness.pageCheckedIds,
        checkedIdsAll: state => state.startingBusiness.checkedIds,
        startingBusinessDetail: state => state.startingBusiness.detail,
      }),
      page () {
        return this.$route.query.page
      },
      perPage () {
        return this.$route.query.perPage
      },
    },
    watch: {
      $route () {
        this.avoidBlank()
      },
    },
    methods: {
      ...mapMutations('startingBusiness', ['check', 'uncheck', 'uncheckAll']),
      ...mapActions('startingBusiness', ['toggleCheck', 'togglePageCheck']),
      sort ({ orderedColumns, checkedKeys }) {
        this.columns = orderedColumns
        this.displayedColumns = checkedKeys
      },
      displayDetailModal ({ id }) {
        if (id !== this.startingBusinessDetail.id) {
          this.$store.dispatch('startingBusiness/fetchDetail', { id })
            .then(() => {
              this.openJobShowModal = true
            })
        } else {
          this.openJobShowModal = !this.openJobShowModal
        }
      },
      handleScroll () {
        if (this.spMode) {
          this.headerFixedSp = (window.scrollY > 60)
        } else {
          this.headerFixedSp = false
        }
      },
      hideJobShowModal () {
        this.openJobShowModal = false
      },
      async selectPage (page) {
        this.reload({ page })
      },
      async selectPerPage (perPage) {
        this.updateJobsPerPage(perPage)
        this.reload({ perPage, page: '1' })
      },
      reload ({ perPage, page } = {}) {
        const { name, query } = this.$route
        this.$router.push({
          name,
          query: {
            ...query,
            perPage: perPage || query.perPage,
            page: page || query.page,
            _t: Date.now(),
          },
        })
      },
      reloadOrSkip () {
        if (this.spMode) {
          return
        }
        this.reload()
      },
      skipReload () {},
      avoidBlank () {
        const { query } = this.$route
        const page = parseInt(query.page, 10) || 1

        // 直近の fetchIndex がエラーで終わった場合は page-- しない。
        // 取得失敗で空配列になった画面で page-- を続けるとエラーループになる。
        if (this.$store.state.startingBusiness.lastFetchError) return

        // 連射防止: API エラー時に暴走して連続リクエストを飛ばすのを防ぐ
        // eslint-disable-next-line no-underscore-dangle
        if (this._avoidBlankGuard) return

        if (!this.index.length && page > 1) {
          // eslint-disable-next-line no-underscore-dangle
          this._avoidBlankGuard = true
          // eslint-disable-next-line no-underscore-dangle
          setTimeout(() => { this._avoidBlankGuard = false }, 3000)
          this.$router.push({ query: { ...query, page: page - 1 } })
        }
      },
      async search () {
        this.$store.commit('common/lockGlobal')
        try {
          const query = this.query(new Date().getTime())
          this.$router.push({ name: 'SearchJob', query })
        } finally {
          this.$store.commit('common/unlockGlobal')
        }
      },
      toggleSidebar () {
        this.openSidebar = !this.openSidebar
      },
      async updateJobsPerPage (jobsPerPage) {
        this.$store.commit('common/lockGlobal')
        try {
          await this.$store.dispatch('user/updateJobsPerPage', { jobsPerPage })
        } finally {
          this.$store.commit('common/unlockGlobal')
        }
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/search/SearchStartingBusiness.vue